import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { AlertIcon } from '../AlertIcon/AlertIcon';
function getAlertClasses(type) {
    switch (type) {
        case 'error':
            return 'text-red-700 bg-red-100 dark:bg-red-200 dark:text-red-800';
        case 'info':
            return 'text-blue-700 bg-blue-100 dark:bg-blue-200 dark:text-blue-800';
        case 'success':
            return 'text-green-700 bg-green-100 dark:bg-green-200 dark:text-green-800';
        case 'warning':
            return 'text-yellow-700 bg-yellow-100 dark:bg-yellow-200 dark:text-yellow-800';
        default:
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            throw new Error(`Unknown status type: ${type}`);
    }
}
// https://flowbite.com/docs/components/alerts/
function Alert({ type, icon, className, children }) {
    const alertClasses = getAlertClasses(type);
    return (_jsxs("div", { className: clsx('flex items-center rounded-lg p-4', alertClasses, className), role: "alert", children: [icon === undefined ? _jsx(AlertIcon, { className: "mr-2", type: type }) : icon, _jsx("div", { children: children })] }));
}
Alert.WithStatus = function AlertWithStatus({ status, ...props }) {
    if (!status) {
        return null;
    }
    return (_jsx(Alert, { type: status.type, ...props, children: status.message }));
};
export { Alert };
//# sourceMappingURL=Alert.js.map